/** Um destaque do padrão do sistema, já com a página do portal que ele abre. */
export interface DestaquePadrao {
  id: string;
  titulo: string;
  descricao: string;
  /** Nome do ícone Lucide. */
  icone: string;
  /** Cor do ponto no canto do card. */
  cor: string;
  caminho: string;
}

/**
 * Os cinco destaques que o portal publica quando o órgão está no "Padrão do sistema", quando
 * não há escolha gravada e quando a leitura falha. São iguais para todo órgão (decisão da
 * usuária de 26/10/2026) e iguais ao `DESTAQUES_PADRAO` do adm, que mostra estes cinco na
 * prévia: mudar um lado exige mudar o outro.
 *
 * Nada aqui pode ser dado de um município só (a descrição de Outros canais perdeu o
 * "Central 125" do seed por isso).
 */
export const DESTAQUES_PADRAO: readonly DestaquePadrao[] = [
  {
    id: 'politica-atendimento',
    titulo: 'Política de atendimento',
    descricao: 'Conheça nossas políticas de atendimento',
    icone: 'file-text',
    cor: '#2563eb',
    caminho: '/politica-atendimento',
  },
  {
    id: 'outros-canais-atendimento',
    titulo: 'Outros canais de atendimento',
    descricao: 'Telefone, portal, aplicativo e atendimento presencial',
    icone: 'headphones',
    cor: '#7c3aed',
    caminho: '/outros-canais-atendimento',
  },
  {
    id: 'lgpd',
    titulo: 'LGPD e Privacidade',
    descricao: 'Saiba como tratamos seus dados pessoais',
    icone: 'shield',
    cor: '#16a34a',
    caminho: '/lgpd',
  },
  {
    id: 'perguntas-frequentes',
    titulo: 'Perguntas frequentes',
    descricao: 'Encontre respostas para dúvidas comuns',
    icone: 'circle-question-mark',
    cor: '#f59e0b',
    caminho: '/perguntas-frequentes',
  },
  {
    id: 'sic',
    titulo: 'SIC',
    descricao: 'Acesse o SIC e tire suas dúvidas',
    icone: 'megaphone',
    cor: '#0891b2',
    caminho: '/sic',
  },
];
